export function getPaymentSummary(source) {
  if (!source) return null;
  if (source.paymentSummary) {
    return source.paymentSummary;
  }
  if (source.subtotal != null && source.grandTotal != null) {
    return {
      subtotal: source.subtotal,
      stateTaxTotal: source.stateTaxTotal ?? 0,
      municipalTaxTotal: source.municipalTaxTotal ?? 0,
      taxTotal: source.taxTotal ?? 0,
      grandTotal: source.grandTotal,
      currency: source.currency || 'USD',
    };
  }
  return null;
}

export function formatMoney(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return '$0.00';
  return `$${n.toFixed(2)}`;
}

export function mergePaymentFields(target, source) {
  if (!source) return target;
  const summary = getPaymentSummary(source);
  return {
    ...target,
    paymentSummary: summary || target.paymentSummary,
    subtotal: source.subtotal ?? target.subtotal,
    stateTaxTotal: source.stateTaxTotal ?? target.stateTaxTotal,
    municipalTaxTotal: source.municipalTaxTotal ?? target.municipalTaxTotal,
    taxTotal: source.taxTotal ?? target.taxTotal,
    grandTotal: source.grandTotal ?? target.grandTotal,
  };
}

export function getPaymentPreviewRequestBody(order, options = {}) {
  if (!order?.products?.length) return null;

  const supplierId = order.supplierId || order.supplier?.[0]?._id;
  const companyId = order.companyId || order.company?.[0]?._id;
  if (!supplierId || !companyId) return null;

  return {
    products: order.products,
    shipVia: options.shipVia ?? order.shipVia ?? order.company?.[0]?.shipVia ?? '',
    supplierId: String(supplierId),
    companyId: String(companyId),
  };
}

export function mergePaymentPreview(order, paymentSummary) {
  if (!paymentSummary) return order;
  return mergePaymentFields(order, { paymentSummary, ...paymentSummary });
}
